export default __webpack_public_path__ + "static/media/icon-open-collapse.162025bd.svg";